import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';
import { currentPlanQuery as CurrentPlanQueryData } from './types/currentPlanQuery';

const currentPlanQuery = gql`
  query currentPlanQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      activeOfferId
      currentPlan: planV2 {
        amount
        hasMeteredBilling
        id
        interval
        isInPlanGroup
        name
        tiers {
          numTasks
          pricePerTask
        }
      }
    }
  }
`;

type Props = {
  skip?: boolean;
};

export const useCurrentPlan = ({ skip }: Props = {}) => {
  const { accountId } = useCurrentAccountId({ skip });

  const { data, error, loading } = useQuery<CurrentPlanQueryData>(
    currentPlanQuery,
    {
      skip: skip || !accountId,
      variables: {
        accountId,
      },
    }
  );

  return {
    currentPlan: data?.account?.currentPlan,
    error: error ? 'Error loading plan information.' : undefined,
    isLoading: loading,
    isPromoPlan: !!data?.account?.activeOfferId,
  };
};
